import { CreateOrdersStatus, EntryAudioRecordStatus } from 'chaika-enums';

export const enum EntryTranscriptionEvents {
    StatusUpdated = 'EntryTranscriptionStatusUpdated',
    PlanOrdersStatusUpdated = 'EntryPlanOrdersStatusUpdated',
}

interface EntryTranscriptionEventData<Body = {}> {
    body: Body;
    name: EntryTranscriptionEvents;
    entityId: string;
    entityType: 'EntryTranscription';
    occurredOn: string;
}

export interface EntryTranscriptionStatusUpdatedBody {
    entryId: string;
    status: EntryAudioRecordStatus;
    errorMessage?: string;
}

export interface EntryTranscriptionStatusUpdatedEventData
    extends EntryTranscriptionEventData<EntryTranscriptionStatusUpdatedBody> {}

export interface EntryPlanOrdersStatusUpdatedBody {
    entryId: string;
    status: CreateOrdersStatus;
}

export interface EntryPlanOrdersStatusUpdatedEventData
    extends EntryTranscriptionEventData<EntryPlanOrdersStatusUpdatedBody> {}
